export const UPDATE_CALENDAR_EVENT_STATUS = `UPDATE_CALENDAR_EVENT_STATUS`

export const UPDATE_EVENT_STATUS = `UPDATE_EVENT_STATUS`
export const UPDATE_EVENT_STATUS_FAILED = `UPDATE_EVENT_STATUS_FAILED`

export const REQUEST_STATUS_TRANSITION_LIST = `REQUEST_STATUS_TRANSITION_LIST`
export const REQUEST_STATUS_TRANSITION_LIST_SUCCEEDED = `REQUEST_STATUS_TRANSITION_LIST_SUCCEEDED`
export const REQUEST_STATUS_TRANSITION_LIST_FAILED = `REQUEST_STATUS_TRANSITION_LIST_FAILED`

export const READ_ALL_AVAILABLE_STATUSES = `READ_ALL_AVAILABLE_STATUSES`
export const READ_ALL_AVAILABLE_STATUSES_SUCCEEDED = `READ_ALL_AVAILABLE_STATUSES_SUCCEEDED`
export const READ_ALL_AVAILABLE_STATUSES_FAILED = `READ_ALL_AVAILABLE_STATUSES_FAILED`
